import{n as e,r as i,y as c}from"../../../493beda6.js";customElements.define("cai-icon-behance",class extends e{static get styles(){return i`
      :host {
        display: inline-block;
        width: var(--cai-icon-width, 16px);
        height: var(--cai-icon-height, 16px);
      }

      svg {
        width: 100%;
        height: 100%;
        fill: var(--cai-icon-fill, currentColor);
      }

      path {
      }
    `}render(){return c`<svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      part="svg"
    >
      <g fill="none" fill-rule="evenodd">
        <path
          d="M19.816 24H4.184A4.184 4.184 0 0 1 0 19.816V4.184A4.184 4.184 0 0 1 4.184 0h15.632A4.184 4.184 0 0 1 24 4.184v15.632A4.184 4.184 0 0 1 19.816 24"
          fill="#000"
        />
        <path
          d="M17.626 9.726c.792.178 1.6.819 1.978 1.712.325.769.407 1.574.338 2.443H14.84c-.113.569.217 1.24.755 1.506.647.318 1.31.294 1.96.009.336-.147.451-.334.612-.858h1.704c.001.783-.243 1.42-.835 1.906-.438.359-.955.548-1.504.643a5.504 5.504 0 0 1-2.356-.078c-1.138-.298-1.904-1.008-2.271-2.125-.428-1.301-.271-2.553.43-3.72.643-1.068 1.658-1.53 2.865-1.575a5.59 5.59 0 0 1 1.425.137ZM9.105 7.053c.58 0 1.138.09 1.642.387.947.558 1.248 1.44 1.181 2.478-.05.784-.43 1.341-1.2 1.594-.03.01-.057.035-.11.07.864.098 1.317.617 1.536 1.379.177.619.186 1.25.045 1.875-.25 1.1-.993 1.713-2.042 1.99a3.87 3.87 0 0 1-.948.127c-.325.003-.72.004-1.145.004H6.516c-.885-.002-1.708-.006-2.159-.008h-.262L4 16.947V7.07h.093l.157-.001 2.665-.01h.438l1.417-.005h.335Zm-2.624 5.505c-.069 0-.137.01-.218.015v2.612c.998 0 1.966.016 2.934-.006.479-.011.815-.322.93-.78.09-.361.084-.723-.03-1.08-.157-.494-.513-.759-1.03-.76-.862-.004-1.725-.002-2.586 0Zm10.052-1.537a1.682 1.682 0 0 0-1.719 1.524h3.21c-.025-.943-.603-1.515-1.491-1.524ZM8.97 8.81c-.808.022-1.618.005-2.427.006-.093 0-.187.009-.293.014v2.03c0 .042.006.085.011.155.973 0 1.915.007 2.857-.004.332-.003.572-.197.63-.515.061-.327.087-.672.052-1.002-.042-.393-.312-.699-.83-.684Zm9.455-1.157v1.187h-4.048V7.654h4.048Z"
          fill="#FFF"
        />
      </g>
    </svg>`}});
